module.exports = __webpack_public_path__ + "static/media/live-monitoring.f265b2f2.svg";